module.exports = __webpack_public_path__ + "static/media/1000.fb9ed448.svg";